import { c } from 'react-compiler-runtime';
import { Announce } from './Announce.js';
import { jsx } from 'react/jsx-runtime';

function AriaAlert(props) {
  var _props$announceOnShow;
  const $ = c(3);
  const t0 = (_props$announceOnShow = props.announceOnShow) !== null && _props$announceOnShow !== void 0 ? _props$announceOnShow : true;
  let t1;
  if ($[0] !== props || $[1] !== t0) {
    t1 = /*#__PURE__*/jsx(Announce, {
      ...props,
      announceOnShow: t0,
      politeness: "assertive"
    });
    $[0] = props;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}

export { AriaAlert };
